import { Component, OnInit, ViewChild } from '@angular/core'
import { FormBuilder } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { StatisticsDistributedService } from '../statistics-distributed/services/statistics-distributed.service';
import { ModalDirective } from 'ngx-bootstrap';
import { BatchService } from '../../qrcode/batchstamp/batch.service';
import { ExportService } from 'app/common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-statistics-distributed',
  templateUrl: './statistics-distributed.component.html',
  styleUrls: ['./statistics-distributed.component.css'],
  providers: [StatisticsDistributedService]
})
export class StatisticsDistributedComponent implements OnInit {
  @ViewChild('detailAgency') detailAgency: ModalDirective;

  public params_search_account_icheck: string;
  public no_product = 'assets/images/no_product.png';
  /** Thống kê**/
  public dataOverview: {
    ordered: 0,
    takeBack: 0,
    refunded: 0,
    revoke: 0,
    inventory: 0,
    returned: 0,
    saleOut: 0
  };

  public messageExport = '';

  /** Tồn kho doanh nghiệp theo sản phẩm **/
  public dataInventoryProduct = [];
  public pageIndexInventoryProduct = 1;
  public pageSizeInventoryProduct = 10;
  public totalInventoryProduct = 0;
  public loadingInventoryProduct = false;
  public queryInventoryProduct = {
    page: undefined,
    pageSize: undefined,
    productId: undefined
  };
  public formInventoryPoduct = this.fb.group([]);
  /** Tồn kho doanh nghiệp theo lô tem **/
  public dataInventoryStamp = [];
  public pageIndexInventoryStamp = 1;
  public pageSizeInventoryStamp = 10;
  public totalInventoryStamp = 0;
  public loadingInventoryStamp = false;
  public queryInventoryStamp = {
    page: undefined,
    pageSize: undefined,
    batchId: undefined
  };
  public formInventoryStamp = this.fb.group([]);
  /** Phân phối theo đại lý **/
  public dataDistributedAgency = [];
  public pageIndexDistributedAgency = 1;
  public pageSizeDistributedAgency = 10;
  public totalDistributedAgency = 0;
  public loadingDistributedAgency = false;
  public queryDistributedAgency = {
    page: undefined,
    pageSize: undefined,
    agencyId: undefined
  };
  public formDistributedAgency = this.fb.group([]);
  public tabBase: any = 1;
  public pageIndexAgencyProduct = 1;
  public pageSizeAgencyProduct = 10;
  public loading_agency_product = false;
  public dataAgencyProduct = [];
  public totalAgencyProduct = 0;
  public queryAgencyProduct = {
    page: undefined,
    pageSize: undefined
  }
  public pageIndexAgencyStamp = 1;
  public pageSizeAgencyStamp = 10;
  public loading_agency_stamp = false;
  public dataAgencyStamp = [];
  public totalAgencyStamp = 0;
  public queryAgencyStamp = {
    page: undefined,
    pageSize: undefined
  }
  public idDetailAgencyProduct: any;
  public nameDetailAgency: any;

  /** Cảnh báo tràn hàng theo khu vực **/
  public totalWarning = 0;
  public dataWarning = [];
  public dataWarningFilter = [];

  constructor(
    private statisticsDistributedService: StatisticsDistributedService,
    private exportService: ExportService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private batchService: BatchService,
    private translate: TranslateService
  ) {
  }

  async ngOnInit() {
    const that = this;
    $('#statisticProduct').select2({
      placeholder: this.translate.instant('SAN_PHAM'),
      allowClear: true,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/products`,
        headers: {
          authorization: localStorage.getItem('Access-Token'),
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          if (params.term !== undefined) {
            that.params_search_account_icheck = params.term;
          }
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        processResults: function (data) {
          return {
            results: data.data.products.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    $('#statisticStamp').select2({
      placeholder: this.translate.instant('TEN_LO'),
      allowClear: true,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            console.log('params.term', params.term)
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_child: 0,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_child: 0,
          };
        },
        processResults: function (data) {
          console.log('data.data ', data.data);
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  console.log('tloggggg', {
                    text: item.name,
                    id: item.id,
                  });
                  return {
                    text: item.name,
                    id: item.id,
                  };
                })
                : [],
          };
        },
      },
    });
    // distributionAgent
    const distributionAgent = $('#distributionAgent');
    distributionAgent.select2({
      placeholder: this.translate.instant('SELECT_DISTRIBUTOR'),
      allowClear: true,
      ajax: {
        delay: 500,
        url: `${environment.qrcode_url}/agencies`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          console.log('params11', params);
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 50,
            };
          }
          return {
            offset: 0,
            limit: 50,
          };
        },
        // tslint:disable-next-line:no-shadowed-variable
        processResults: (data) => {
          // this.fakeData = data.data.items;
          // console.log('data', this.fakeData)
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });
    this.getListInventoryProduct();
    this.getListInventoryStamp();
    this.getStatisticOverView();
    this.getListDistributedAgency();
    this.getWarningOverFollow()
  }

  /** Thông kê **/
  getStatisticOverView() {
    this.statisticsDistributedService.getOverviewDistributed().subscribe((res) => {
      if (res.code == 1) {
        this.dataOverview = res.data
        console.log('this.dataover', this.dataOverview)
      }
    })
  }

  /** Thống kê theo sản phẩm của doanh nghiệp **/
  searchInventoryProduct() {
    this.pageIndexInventoryProduct = 1;
    this.getListInventoryProduct();
  }

  resetInventoryProduct() {
    $('#statisticProduct').val('').trigger('change');
    this.getListInventoryProduct();
  }

  getListInventoryProduct() {
    this.queryInventoryProduct.page = this.pageIndexInventoryProduct;
    this.queryInventoryProduct.pageSize = this.pageSizeInventoryProduct;
    this.queryInventoryProduct.productId = $('#statisticProduct').val() ? $('#statisticProduct').val() : '';
    this.statisticsDistributedService.getInvetoryProduct(this.queryInventoryProduct).subscribe((res) => {
      if (res.code == 1 && res.data) {
        this.totalInventoryProduct = res.data.totalElement
        this.dataInventoryProduct = res.data.items
        console.log('this.dataInventoryProduct', this.totalInventoryProduct)
      } else {
        this.loadingInventoryProduct = false;
        this.totalInventoryProduct = 0;
        this.dataInventoryProduct = [];
      }
    }, (error) => {
      this.loadingInventoryProduct = false;
      this.totalInventoryProduct = 0;
      this.dataInventoryProduct = [];
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }


  inputInventoryProduct(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexInventoryProduct) {
      this.pageIndexInventoryProduct = page;
      this.getListInventoryProduct();
    }
  }

  preInventoryProduct() {
    this.pageIndexInventoryProduct = this.pageIndexInventoryProduct - 1;
    this.getListInventoryProduct();
  }

  lastInventoryProduct() {
    if (this.pageIndexInventoryProduct * this.pageSizeInventoryProduct < this.totalInventoryProduct) {
      this.pageIndexInventoryProduct = this.pageIndexInventoryProduct + 1;
      this.getListInventoryProduct();
    }
  }

  /** Tồn kho theo lô tem của doanh nghiệp **/
  searchInventoryStamp() {
    this.pageIndexInventoryStamp = 1;
    this.getListInventoryStamp();
  }

  resetInventoryStamp() {
    $('#statisticStamp').val('').trigger('change');
    this.getListInventoryStamp();
  }

  getListInventoryStamp() {
    this.queryInventoryStamp.page = this.pageIndexInventoryStamp;
    this.queryInventoryStamp.pageSize = this.pageSizeInventoryStamp;
    this.queryInventoryStamp.batchId = $('#statisticStamp').val();
    console.log('$val()', $('#statisticStamp').val())
    this.statisticsDistributedService.getInvetoryStamp(this.queryInventoryStamp).subscribe((res) => {
      if (res.code == 1 && res.data) {

        this.totalInventoryStamp = res.data.totalElement
        this.dataInventoryStamp = res.data.items
        console.log('dataInventoryStamp', this.dataInventoryStamp)
      } else {
        this.loadingInventoryStamp = false;
        this.totalInventoryStamp = 0;
        this.dataInventoryStamp = [];
      }
    }, (error) => {
      this.loadingInventoryStamp = false;
      this.totalInventoryStamp = 0;
      this.dataInventoryStamp = [];
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }

  inputInventoryStamp(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexInventoryStamp) {
      this.pageIndexInventoryStamp = page;
      this.getListInventoryStamp();
    }
  }

  preInventoryStamp() {
    this.pageIndexInventoryStamp = this.pageIndexInventoryStamp - 1;
    this.getListInventoryStamp();
  }

  lastInventoryStamp() {

    if (this.pageIndexInventoryStamp * this.pageSizeInventoryStamp < this.totalInventoryStamp) {
      this.pageIndexInventoryStamp = this.pageIndexInventoryStamp + 1;
      console.log(123123123123123123123)
      this.getListInventoryStamp();
    }
  }


  /** Phân phối theo đại lý doanh nghiệp **/
  searchDistributedAgency() {
    this.pageIndexDistributedAgency = 1;
    this.getListDistributedAgency();
  }

  resetDistributedAgency() {
    $('#distributionAgent').val('').trigger('change');
    this.getListDistributedAgency();
  }

  getListDistributedAgency() {
    this.queryDistributedAgency.page = this.pageIndexDistributedAgency;
    this.queryDistributedAgency.pageSize = this.pageSizeDistributedAgency;
    this.queryDistributedAgency.agencyId = $('#distributionAgent').val();
    this.statisticsDistributedService.getDistributedAgency(this.queryDistributedAgency).subscribe((res) => {
      if (res.code == 1 && res.data) {
        this.totalDistributedAgency = res.data.totalElement
        this.dataDistributedAgency = res.data.items
      } else {
        this.loadingDistributedAgency = false;
        this.totalDistributedAgency = 0;
        this.dataDistributedAgency = [];
      }
    }, (error) => {
      this.loadingDistributedAgency = false;
      this.totalDistributedAgency = 0;
      this.dataDistributedAgency = [];
      this.toastr.error(error.message, this.translate.instant('CANH_BAO'), {
        timeOut: 4000,
        positionClass: 'toastr-bottom-right'
      })
    })
  }

  inputDistributedAgency(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexDistributedAgency) {
      this.pageIndexDistributedAgency = page;
      this.getListDistributedAgency();
    }
  }

  preDistributedAgency() {
    this.pageIndexDistributedAgency = this.pageIndexDistributedAgency - 1;
    this.getListDistributedAgency();
  }

  lastDistributedAgency() {
    if (this.pageIndexDistributedAgency * this.pageSizeDistributedAgency < this.totalDistributedAgency) {
      this.pageIndexDistributedAgency = this.pageIndexDistributedAgency + 1;
      this.getListDistributedAgency();
    }
  }

  /** Cảnh báo tràn hàng theo khu vực **/

  getWarningOverFollow() {
    const datafilter = [];
    this.statisticsDistributedService.getOverfollow().subscribe((res) => {
      console.log('this.warning', res)
      if (res.code == 1) {
        this.dataWarning = res.data.items
        this.dataWarning.map((val) => {
          this.totalWarning += Number(val.overflow)
        })
        this.dataWarning.map((item) => {
          item['percent'] = Number(((item.overflow / this.totalWarning) * 100).toFixed());
          datafilter.push(item)
        })
        this.dataWarningFilter = datafilter
        console.log('dataWarningFilter', this.dataWarningFilter)
      }
    })
  }

  /** Modal chi tiết đại lý**/


  loadListAgencyProduct(id: any) {
    this.loading_agency_product = true;
    this.queryAgencyProduct.page = this.pageIndexAgencyProduct;
    this.queryAgencyProduct.pageSize = this.pageSizeAgencyProduct;
    this.statisticsDistributedService
      .getListAgencyProduct(this.queryAgencyProduct, id)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.dataAgencyProduct = res.data.items;
            this.totalAgencyProduct = res.data.totalElement;
            this.loading_agency_product = false;
            return;
          } else {
            this.dataAgencyProduct = [];
            this.totalAgencyProduct = 0;
            this.loading_agency_product = false;
          }
        },
        (error) => {
          this.dataAgencyProduct = [];
          this.totalAgencyProduct = 0;
          this.loading_agency_product = false;
        }
      );
  }

  inputAgencyProduct(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexAgencyProduct) {
      this.pageIndexAgencyProduct = page;
      this.loadListAgencyProduct(this.idDetailAgencyProduct);
    }
  }

  preAgencyProduct() {
    this.pageIndexAgencyProduct = this.pageIndexAgencyProduct - 1;
    this.loadListAgencyProduct(this.idDetailAgencyProduct);
  }

  lastAgencyProduct() {
    if (this.pageIndexAgencyProduct * this.pageSizeAgencyProduct < this.totalAgencyProduct) {
      this.pageIndexAgencyProduct = this.pageIndexAgencyProduct + 1;
      this.loadListAgencyProduct(this.idDetailAgencyProduct);
    }
  }

  loadListAgencyBatch(id: any) {
    this.loading_agency_stamp = true;
    this.queryAgencyStamp.page = this.pageIndexAgencyStamp;
    this.queryAgencyStamp.pageSize = this.pageSizeAgencyStamp;
    this.statisticsDistributedService
      .getListAgencyBatch(this.queryAgencyStamp, id)
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.dataAgencyStamp = res.data.items;
            this.totalAgencyStamp = res.data.totalElement;
            this.loading_agency_stamp = false;
            return;
          } else {
            this.dataAgencyStamp = [];
            this.totalAgencyStamp = 0;
            this.loading_agency_stamp = false;
          }
        },
        (error) => {
          this.dataAgencyStamp = [];
          this.totalAgencyStamp = 0;
          this.loading_agency_stamp = false;
        }
      );
  }

  inputAgencyStamp(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndexAgencyStamp) {
      this.pageIndexAgencyStamp = page;
      this.loadListAgencyBatch(this.idDetailAgencyProduct);
    }
  }

  preAgencyStamp() {
    this.pageIndexAgencyStamp = this.pageIndexAgencyStamp - 1;
    this.loadListAgencyBatch(this.idDetailAgencyProduct);
  }

  lastAgencyStamp() {
    if (this.pageIndexAgencyStamp * this.pageSizeAgencyProduct < this.totalAgencyStamp) {
      this.pageIndexAgencyStamp = this.pageIndexAgencyStamp + 1;
      this.loadListAgencyBatch(this.idDetailAgencyProduct);
    }
  }

  changeTab(e: any) {
    this.tabBase = e
    console.log('this.tabbase', this.tabBase)
  }

  closeModalDetailAgency() {
    this.detailAgency.hide();
    this.tabBase = 1
  }

  showModalDetailAgency(item: any) {
    this.nameDetailAgency = item.agencyName;
    this.loadListAgencyBatch(item.agencyId);
    this.detailAgency.show();
    this.idDetailAgencyProduct = item.agencyId;
    if (this.tabBase == 1) {
      this.loadListAgencyProduct(item.agencyId);
    }
    if (this.tabBase == 2) {
      this.loadListAgencyBatch(item.agencyId);
    }
  }

  /** TuanHA: 16-11-2022: ExportReport */
  exportReport(type) {
    this.messageExport = '';
    const body = {
      exportTypeEnum: '',
      fields: {}
    };
    body.exportTypeEnum = type;
    switch (type) {
      case 'DISTRIBUTION_PRODUCT_STATISTIC':
        if ($('#statisticProduct').val()) {
          body.fields['productId'] = $('#statisticProduct').val();
        }
        break;
      case 'DISTRIBUTION_BATCH_STATISTIC':
        if ($('#statisticStamp').val()) {
          body.fields['batchId'] = $('#statisticStamp').val();
        }
        break;
      case 'DISTRIBUTION_AGENCY_STATISTIC':
        if ($('#distributionAgent').val()) {
          body.fields['agencyId'] = $('#distributionAgent').val();
        }
        break;
      case 'DISTRIBUTION_WARING_LOCATION_STATISTIC':
        break;
    }
    this.exportService.exportReportStatistic(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('SYSTEM_PROCESSING_FILE');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      console.log('123123', 123123)
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics-distributed/statistics-distributed.component.ts